import { useEffect, useState } from "react";
import { useSamarthDashboardContext } from "utils/samarth-dashboard-context/hooks/useSamarthDashboardContext";
import WidgetWrapper from "../widget-wrapper/widget-wrapper";
import ChartSkeleton from "../../ui/chart-skeleton/chart-skeleton";
import SingleLineCharts from "../../ui/SinglelineCharts/singlelineCharts";
import HorizonaylCharts from "../../ui/HorizontalCharts/HorizonaylCharts";
import SingleTabTable from "../../ui/SingleTabTable";
import styles from "../maiWidgets/mai-widget.module.css";

export default function MSTNWidget() {
  const {  state } = useSamarthDashboardContext();
  const globalViewMode = state.viewMode.globalViewMode;
  const actionFilter = state.filters.actionFilter;
  const isFilter = Boolean(actionFilter?.length);

  const depotData = state.dashboardData.mstn;
  const factoryData = state.dashboardData.mstnFactory;
  const loader = state.dashboardData.isLoading.mstn;
  const currWeek = state.filters.weekFilter;

  const [isOn, setIsOn] = useState(false);
  const [isPopup, setIsPopup] = useState(false);
  const [visibleData, setVisibleData] = useState([]);

  useEffect(() => {
    const selectedData = isOn ? factoryData : depotData;
    const selectedSource = isOn ? factoryData[0] : depotData[0];

    if (isFilter) {
      const weekKey = globalViewMode === 'graph' ? currWeek || 'Week 21' : 'Week 21';
      const weekData = selectedSource?.[weekKey] || [];

      setVisibleData(isPopup ? weekData : weekData.slice(0, 4));
    } else {
      setVisibleData(isPopup ? selectedData : selectedData.slice(0, 4));
    }
  }, [factoryData, depotData, isPopup, isOn, currWeek, globalViewMode, isFilter]);

  const handleToggle = () => setIsPopup((prev) => !prev);

  return (
    <WidgetWrapper
      title="MSTN Factory-Depot"
      isTableView={globalViewMode === 'table'}
      showBlueDot
      isOn={isOn}
      setIsOn={setIsOn}
      toogleLables={['F', 'D']}
      isDialogOpen={isPopup}
      setIsDialogOpen={handleToggle}
      isEpandable={false}
      infoText="MSTN measures Minimum value of Projected Stock to Replenishment stock."
    >
      {loader ? (
        <ChartSkeleton isOn={isPopup} height="140px" />
      ) : (
        <div style={{ height: '100%', maxWidth: '1200px', opacity: 0.25, pointerEvents: 'none' }}>
          {globalViewMode === 'graph' ? (
            isFilter ? (
              <SingleLineCharts data={visibleData} />
            ) : (

             <div style={{ height: '100%'}}>
              <HorizonaylCharts data={visibleData} />
            </div>
            )
          ) : (
            <SingleTabTable
              data={visibleData}
              keys={['week', 'value']}
              colorLogic={(value) => {
                if (value >= 60) return styles.textGreen;
                if (value >= 50) return styles.textYellow;
                return styles.textRed;
              }}
            />
          )}
        </div>
      )}
    </WidgetWrapper>
  );
}
